import { Component } from '@angular/core';

@Component({
  selector: 'laps-forbidden',
  templateUrl: './forbidden.component.html',
})
export class ForbiddenComponent {}
